"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCollectionTimeRange = exports.calculateDeliveryTimeRange = exports.calcMoreCookTimeIfManyItems = exports.ADDED_TIME_PER_ITEM_IN_BASKET = exports.MAX_NUMBER_OF_ITEMS_IN_ORDER_THAT_CAN_BE_COOKED_IN_COOK_TIME = exports.ORDER_TO_COLLECTION_TIME_ERROR = exports.ORDER_TO_DELIVERY_TIME_ERROR = exports.TIME_ORDER_IS_OUT_FOR_DELIVERY = exports.TIME_TO_COOK_AN_ORDER_IN_MINS = void 0;
const lodash_1 = require("lodash");
const date_fns_1 = require("date-fns");
exports.TIME_TO_COOK_AN_ORDER_IN_MINS = 15;
exports.TIME_ORDER_IS_OUT_FOR_DELIVERY = 10;
exports.ORDER_TO_DELIVERY_TIME_ERROR = 10;
exports.ORDER_TO_COLLECTION_TIME_ERROR = 5;
exports.MAX_NUMBER_OF_ITEMS_IN_ORDER_THAT_CAN_BE_COOKED_IN_COOK_TIME = 5;
exports.ADDED_TIME_PER_ITEM_IN_BASKET = 2;
const calcMoreCookTimeIfManyItems = (items) => {
    if (!items)
        return 0;
    let additional_cook_time = 0;
    const numberOfItemsInBasket = (0, lodash_1.keys)(items).length;
    if (numberOfItemsInBasket > exports.MAX_NUMBER_OF_ITEMS_IN_ORDER_THAT_CAN_BE_COOKED_IN_COOK_TIME) {
        const additionalItems = numberOfItemsInBasket - exports.MAX_NUMBER_OF_ITEMS_IN_ORDER_THAT_CAN_BE_COOKED_IN_COOK_TIME;
        additional_cook_time = additionalItems * exports.ADDED_TIME_PER_ITEM_IN_BASKET;
    }
    return additional_cook_time;
};
exports.calcMoreCookTimeIfManyItems = calcMoreCookTimeIfManyItems;
const calculateDeliveryTimeRange = (items) => {
    const deliveryTimeInMins = (0, exports.calcMoreCookTimeIfManyItems)(items) + exports.TIME_TO_COOK_AN_ORDER_IN_MINS + exports.TIME_ORDER_IS_OUT_FOR_DELIVERY;
    return {
        expectedDeliveryTimeFrom: (0, date_fns_1.formatISO)((0, date_fns_1.add)(new Date(), { minutes: deliveryTimeInMins })),
        expectedDeliveryTimeTo: (0, date_fns_1.formatISO)((0, date_fns_1.add)(new Date(), { minutes: deliveryTimeInMins + exports.ORDER_TO_DELIVERY_TIME_ERROR })),
    };
};
exports.calculateDeliveryTimeRange = calculateDeliveryTimeRange;
const calculateCollectionTimeRange = ({ order = null, additionalTime = 0 } = { order: null, additionalTime: 0 }) => {
    const deliveryTimeInMins = (0, exports.calcMoreCookTimeIfManyItems)(order) + exports.TIME_TO_COOK_AN_ORDER_IN_MINS + additionalTime;
    return {
        expectedDeliveryTimeFrom: (0, date_fns_1.formatISO)((0, date_fns_1.add)(new Date(), { minutes: deliveryTimeInMins })),
        expectedDeliveryTimeTo: (0, date_fns_1.formatISO)((0, date_fns_1.add)(new Date(), { minutes: deliveryTimeInMins + exports.ORDER_TO_COLLECTION_TIME_ERROR })),
    };
};
exports.calculateCollectionTimeRange = calculateCollectionTimeRange;
//# sourceMappingURL=delivery.js.map